export default {
  name: 'login',
  components: {},
  props: [],
  data () {
    return {
      mainMessage: null,
      view: {
        mode: "login"
      },
      form: {
        userEmail: "",
        userPassword: "",
        error: null,
        status: null,
        loading: null
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    }
  },
  mounted () {    

    if(this.$route.query.purpose){
      let purpose = this.$route.query.purpose

      if(purpose === "acceptGuestInvite"){
        this.mainMessage = "to accept invite"
      }
    }

    if(this.user){
      this.$router.push(this.$route.query.redirect)
    }
  },
  methods: {
    async signUpUser () {
      console.log("user wants to sign up: ", this.form)
      this.form.loading = true;
      try { 
        let email = this.form.userEmail;
        let password = this.form.userPassword
        let user = await this.$store.dispatch('signUp', {email, password})
        this.$toast.success("Account created!");

        if(this.$route.query.redirect){
          this.$router.push(this.$route.query.redirect)
        } else {
          this.$router.push("/")
        }
      } catch (error) {
        console.log('error signing up:', error);
        this.form.error = error.code;
        this.$toast.error("Something went wrong signing up :(");
        this.form.loading = false;
      }
    },
    async loginUser () {
      console.log("user wants to login: ", this.form)
      this.form.loading = true

      try { 
        let user = await this.$store.dispatch('signIn', {...this.form})
        
        if(this.$route.query.redirect){
          this.$router.push(this.$route.query.redirect)
        } else {
          this.$router.push("/")
        }
      } catch (error) {
        console.log('error logging in:', error);
        this.form.error = error
        this.$toast.error("Something went wrong logging in.");
        this.form.loading = false;
      }
    }
  }
}
